import AppLoader from '@/components/AppLoader';
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { t } from 'i18next';
import EventDetailsForm from './components/event-details-form/event-details-form.view';
import { useEventDetailsController } from './event-details.controller';

interface IProps {
	isOpen: boolean;
	onClose: () => void;
}

export default function EventDetailsModal(props: IProps) {
	const { query, calendarId } = useEventDetailsController();

	return (
		<Modal isOpen={props.isOpen} onClose={props.onClose} size="xl">
			<ModalOverlay />

			<ModalContent>
				<ModalHeader>{t('Edit event')}</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					{query.data ? (
						<EventDetailsForm onClose={props.onClose} calendarId={calendarId} event={query.data} />
					) : (
						<AppLoader />
					)}
				</ModalBody>
			</ModalContent>
		</Modal>
	);
}
